import {ClientClientBookmarksState} from "../store/client_client_bookmarks_state";
import {Reducer} from "redux";
import {
    ClientClientBookmarksAction,
    ClientClientBookmarksActionType,
    ICallbackGetAllClientBookmarksAction
} from "../action/client_client_bookmarks_action";

const initialState: ClientClientBookmarksState = {
    clientBookmarks: [],
    customers: [],
    jobCareersWithCustomerID: [],
    isLoading: false,
};

const clientClientBookmarksReducer: Reducer<ClientClientBookmarksState> = (state = initialState, action: ClientClientBookmarksAction): ClientClientBookmarksState => {
    switch (action.type) {
        case ClientClientBookmarksActionType.REQUEST_GET_ALL_CLIENT_BOOKMARKS: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientClientBookmarksActionType.CALLBACK_GET_ALL_CLIENT_BOOKMARKS: {
            const _action = action as ICallbackGetAllClientBookmarksAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    isLoading: false,
                    clientBookmarks: _action.item ? _action.item.clientBookmarks : [],
                    customers: _action.item ? _action.item.customers : [],
                    jobCareersWithCustomerID: _action.item ? _action.item.jobCareersWithCustomerID : [],
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }
        default:
            return state;
    }

};

export default clientClientBookmarksReducer;


// WEBPACK FOOTER //
// ./src/presentation/reducer/client_client_bookmarks_reducer.ts